import React, {Fragment, useEffect, useState} from "react";
import useDimension from "../../lib/appfuse-react/hook/useDimension";
import {
    Checkbox,
    Divider,
    FormControl,
    FormControlLabel,
    FormGroup, FormLabel,
    Grid, InputAdornment, Radio, RadioGroup,
    Typography,
    useTheme
} from "@material-ui/core";
import Form from "../../lib/appfuse-react/component/Form";
import SelectField from "../../lib/appfuse-react/component/SelectField";
import ImageField from "../../lib/appfuse-react/component/ImageField";
import UserEvent from "../../lib/appfuse-react/core/UserEvent";
import i18n from "../../lib/appfuse-react/core/i18n";
import Forms, {AddAction, RemoveAction} from "../../lib/appfuse-react/component/Forms";
import Button from "../../lib/appfuse-react/component/Button";
import DataTable, {DataColumn} from "../../lib/appfuse-react/component/DataTable";
import Space from "../../lib/appfuse-react/component/Space";
import Box from "../../lib/appfuse-react/component/Box";
import Address, {MobileAddress} from "../Address";
import {useSelector} from "../../store";
import {selectCounty} from "../../reducer/util/utilReducer";
import code from "../../lib/appfuse-react/core/code";
import lang from "../../lib/appfuse-react/core/lang";
import valueChange from "../Judge/ValueChange";
import agreementService from "../../service/agreement/agreementService";
import RichText from "../../lib/appfuse-react/component/RichText";
import TextField from "../../lib/appfuse-react/component/TextField";
import IconButton from "@material-ui/core/IconButton";
import {Add, Clear, Visibility, VisibilityOff} from "@material-ui/icons";
import useResponsive from "../../lib/appfuse-react/hook/useResponsive";
import DataPagination from "../../lib/appfuse-react/component/DataPagination";

// 基本資料
export function BasicData(props) {
    const dimension = useDimension();
    const theme = useTheme();
    const {value={}, change={}, readOnly, disabled, isNew, reviewRegistration = false, newLecturer = false} = props;
    const county = useSelector(selectCounty);
    const [idNoShow, setIdNoShow] = useState(false);

    const edit = !(readOnly||disabled);
    const variant = !edit? 'standard':'outlined';

    const combine = {...value, ...change};
    const {isTafReviewer} = combine;

    const handleChangeInNew = ({value:newValue, change:newChange}) => {

        const {sameAsServiceOrganizationAddress, mailingAddress} = newChange;
        if(lang.isNotUndefined(sameAsServiceOrganizationAddress) && sameAsServiceOrganizationAddress!==change.sameAsStudentInformation) {
            if(sameAsServiceOrganizationAddress) {
                const serviceOrganizationAddress = valueChange.getEffectiveValue(value.serviceOrganizationAddress, change.serviceOrganizationAddress);
                if(!newChange.mailingAddress) newChange.mailingAddress = {};
                Address.copy(newChange.mailingAddress, serviceOrganizationAddress);
                newValue.mailingAddress = newChange.mailingAddress;
            }
        } else if(lang.isNotUndefined(mailingAddress) && !Address.compare(mailingAddress, change.mailingAddress)) {
            newChange.sameAsServiceOrganizationAddress = false;
            newValue.sameAsServiceOrganizationAddress = false;
        }

        props.onChange(new UserEvent({value:newValue, change:newChange}));
    };

    const handleChange = isNew? handleChangeInNew:props.onChange;

    return (
        <Form value={value} change={change} onChange={handleChange} readOnly={readOnly} disabled={disabled}>
            <Grid container spacing={2} item xs={12}>
                <Grid item xs={9}>
                    <Grid container spacing={2}>
                        {/*姓名(中文)*/}
                        <Grid item xs={4}>
                            <TextField name="chineseName" label="Chinese Name" variant={variant} fullWidth required />
                        </Grid>
                        {/*姓名(英文)*/}
                        <Grid item xs={4}>
                            <TextField name="englishName" label="English Name" variant={variant} fullWidth required />
                        </Grid>
                        {/*性別*/}
                        <Grid item xs={4}>
                            <SelectField name="gender" label="Gender" variant={variant} code='gender' fullWidth required/>
                        </Grid>
                        <Grid item xs={4}>
                            <Form value={value} change={change} onChange={props.onChange}>
                                <TextField name="idNo" label="idNo" variant={variant} fullWidth required
                                           type={idNoShow? "text": "password"}
                                           InputProps={{
                                               endAdornment: (
                                                   <InputAdornment position='end'>
                                                       <IconButton onClick={() => setIdNoShow(!idNoShow)}>
                                                           {idNoShow ? <Visibility/> : <VisibilityOff/>}
                                                       </IconButton>
                                                   </InputAdornment>),
                                           }}/>
                            </Form>
                        </Grid>
                        {/*出生年度*/}
                        <Grid item xs={4}>
                            <TextField name="birthYear" label="Birth Year" variant={variant} type="number" fullWidth required />
                        </Grid>
                        {/*TAF同仁*/}
                        <Grid item xs={4}>
                            <Box fullWidth fullHeight display='flex' alignItems='center'>
                                <FormGroup>
                                    <FormControlLabel name="tafColleague" control={<Checkbox /> } label="TAF Colleague"/>
                                </FormGroup>
                            </Box>
                        </Grid>
                        {/*服務機構*/}
                        <Grid item xs={4}>
                            <TextField name="serviceOrganization" label="Service Organization" variant={variant} fullWidth  />
                        </Grid>
                        {/*服務部門*/}
                        <Grid item xs={4}>
                            <TextField name="serviceDepartment" label="Service Department" variant={variant} fullWidth  />
                        </Grid>
                        {/*職稱*/}
                        <Grid item xs={4}>
                            <TextField name="jobTitle" label="Job Title" variant={variant} fullWidth required />
                        </Grid>
                        {/*授課時出發地*/}
                        <Grid item xs={4}>
                            <SelectField name="departure" label='Departure place during class' variant={variant}
                                         options={county} valueAccessor='code' textAccessor='name' fullWidth required/>
                        </Grid>
                        {/*電子郵件*/}
                        <Grid item xs={4}>
                            <TextField name="email" label="Email" variant={variant} fullWidth required/>
                        </Grid>
                        {/*聯絡電話*/}
                        <Grid item xs={4}>
                            <TextField name="contactTel" label="Contact Telephone" variant={variant} fullWidth required/>
                        </Grid>
                        {/*手機*/}
                        <Grid item xs={4}>
                            <TextField name="mobilePhone" label="Mobile Phone" variant={variant} fullWidth required/>
                        </Grid>
                    </Grid>
                </Grid>
                {/*照片*/}
                <Grid item xs={3}>
                    <ImageField name="photo" label="Photo" variant={variant} accept="image/*" fullWidth
                                height={dimension.formControlHeight() * 4 + theme.spacing(edit? 2:0.5) * 3}/>
                </Grid>

                {/*服務機構地址*/}
                <Grid item xs={12}>
                    <Address name="serviceOrganizationAddress" subtitle="Service Organization Address" variant='outlined' required withoutCountry/>
                </Grid>
                {/*通訊地址*/}
                <Grid item xs={12}>
                    {/*同服務機構地址*/}
                    {
                        isNew && (
                            <Box fullWidth display='flex' alignItems='center'>
                                <Typography variant="subtitle1" color="textSecondary">{i18n.translate('Contact Address')}</Typography>
                                <Space spacing={2}/>
                                <FormControlLabel name='sameAsServiceOrganizationAddress' control={<Checkbox />} label='Same as Service Organization Address' />
                            </Box>
                        )
                    }
                    <Address name="mailingAddress" subtitle={isNew? undefined:'Contact Address'} variant='outlined' withoutCountry/>
                </Grid>

                { !newLecturer && <React.Fragment>
                    <Grid item xs={12}>
                        {/*學歷*/}
                        <CustomizedTable name='educations' title={i18n.translate('Education') + '(' + i18n.translate('must not be null') + ')'}
                                         format={education} type='array' readOnly={readOnly} disabled={disabled}/>
                    </Grid>

                    <Grid item xs={12}>
                        {/*經歷*/}
                        <CustomizedTable name='workExperiences' title={i18n.translate('Work Experience') + '(' + i18n.translate('must not be null') + ')'}
                                         format={work} type='array' readOnly={readOnly} disabled={disabled}/>
                    </Grid>

                    <Grid item xs={12}>
                        {/*曾參加過相關的訓練*/}
                        <CustomizedTable name='trainings' title='Training' format={training}
                                         type='array' readOnly={readOnly} disabled={disabled}/>
                    </Grid>

                    { reviewRegistration && <React.Fragment>
                        <Grid item xs={12}/>
                        <Grid item xs={12}>
                            {/*是否為本會審員*/}
                            <SelectField name={'isTafReviewer'} label={'isTafReviewer'} variant={variant} code={'whether'} fullWidth required/>
                        </Grid>
                    </React.Fragment>}

                    { reviewRegistration && isTafReviewer === 'Y' &&
                        <Grid item xs={12}>
                            <Typography variant={'body1'}>{i18n.translate('Please fill in the evaluation records of the past three years, and click Next if completed.')}</Typography>
                        </Grid>
                    }

                    {/*not reviewRegistration or isTafReviewer == Y*/}
                    { (!reviewRegistration || isTafReviewer === 'Y') &&
                        <Grid item xs={12}>
                            {/*評鑑紀錄*/}
                            <CustomizedTable name='evaluationHistories' title='Evaluation Histories' format={evaluation}
                                             type='array' readOnly={reviewRegistration || readOnly} pagination={reviewRegistration} disabled={disabled}/>
                        </Grid> }

                    { reviewRegistration && isTafReviewer === 'Y' &&
                        // newEvaluationExperiences
                        <Grid item xs={12}>
                            {/*近三年評鑑紀錄*/}
                            <CustomizedTable name='newEvaluationExperiences' title='newEvaluationExperiences' format={evaluation}
                                             type='array' readOnly={readOnly} disabled={disabled}/>
                        </Grid>
                    }
                </React.Fragment>}

            </Grid>
        </Form>
    );
}

export function MobileBasicData(props) {
    const dimension = useDimension();
    const theme = useTheme();
    const {value={}, change={}, readOnly, disabled, isNew, reviewRegistration = false, newLecturer = false} = props;
    const county = useSelector(selectCounty);
    const [idNoShow, setIdNoShow] = useState(false);

    const edit = !(readOnly||disabled);
    const variant = !edit? 'standard':'outlined';

    const combine = {...value, ...change};
    const {isTafReviewer} = combine;

    const handleChangeInNew = ({value:newValue, change:newChange}) => {

        const {sameAsServiceOrganizationAddress, mailingAddress} = newChange;
        if(lang.isNotUndefined(sameAsServiceOrganizationAddress) && sameAsServiceOrganizationAddress!==change.sameAsStudentInformation) {
            if(sameAsServiceOrganizationAddress) {
                const serviceOrganizationAddress = valueChange.getEffectiveValue(value.serviceOrganizationAddress, change.serviceOrganizationAddress);
                if(!newChange.mailingAddress) newChange.mailingAddress = {};
                Address.copy(newChange.mailingAddress, serviceOrganizationAddress);
                newValue.mailingAddress = newChange.mailingAddress;
            }
        } else if(lang.isNotUndefined(mailingAddress) && !Address.compare(mailingAddress, change.mailingAddress)) {
            newChange.sameAsServiceOrganizationAddress = false;
            newValue.sameAsServiceOrganizationAddress = false;
        }

        props.onChange(new UserEvent({value:newValue, change:newChange}));
    };

    const handleChange = isNew? handleChangeInNew:props.onChange;

    return (
        <Form value={value} change={change} onChange={handleChange} readOnly={readOnly} disabled={disabled}>
            <Grid container spacing={2} item xs={12}>
                {/*姓名(中文)*/}
                <Grid item xs={12}>
                    <TextField name="chineseName" label="Chinese Name" variant={variant} fullWidth required />
                </Grid>
                {/*姓名(英文)*/}
                <Grid item xs={12}>
                    <TextField name="englishName" label="English Name" variant={variant} fullWidth required />
                </Grid>
                {/*性別*/}
                <Grid item xs={12}>
                    <SelectField name="gender" label="Gender" variant={variant} code='gender' fullWidth required/>
                </Grid>
                <Grid item xs={12}>
                    <Form value={value} change={change} onChange={props.onChange}>
                        <TextField name="idNo" label="idNo" variant={variant} fullWidth required
                                   type={idNoShow? "text": "password"}
                                   InputProps={{
                                       endAdornment: (
                                           <InputAdornment position='end'>
                                               <IconButton onClick={() => setIdNoShow(!idNoShow)}>
                                                   {idNoShow ? <Visibility/> : <VisibilityOff/>}
                                               </IconButton>
                                           </InputAdornment>),
                                   }}/>
                    </Form>
                </Grid>
                {/*電子郵件*/}
                <Grid item xs={12}>
                    <TextField name="email" label="Email" variant={variant} fullWidth required/>
                </Grid>
                {/*出生年度*/}
                <Grid item xs={12}>
                    <TextField name="birthYear" label="Birth Year" variant={variant} type="number" fullWidth required />
                </Grid>
                {/*TAF同仁*/}
                <Grid item xs={12}>
                    <Box fullWidth fullHeight display='flex' alignItems='center'>
                        <FormGroup>
                            <FormControlLabel name="tafColleague" control={<Checkbox /> } label="TAF Colleague"/>
                        </FormGroup>
                    </Box>
                </Grid>
                {/*服務機構*/}
                <Grid item xs={12}>
                    <TextField name="serviceOrganization" label="Service Organization" variant={variant} fullWidth  />
                </Grid>
                {/*服務部門*/}
                <Grid item xs={12}>
                    <TextField name="serviceDepartment" label="Service Department" variant={variant} fullWidth  />
                </Grid>
                {/*職稱*/}
                <Grid item xs={12}>
                    <TextField name="jobTitle" label="Job Title" variant={variant} fullWidth required />
                </Grid>
                {/*照片*/}
                <Grid item xs={12}>
                    <ImageField name="photo" label="Photo" variant={variant} accept="image/*" fullWidth
                                height={dimension.formControlHeight() * 3 + theme.spacing(edit? 2:0.5) * 2}/>
                </Grid>
                {/*授課時出發地*/}
                <Grid item xs={12}>
                    <SelectField name="departure" label='Departure place during class' variant={variant}
                                 options={county} valueAccessor='code' textAccessor='name' fullWidth required/>
                </Grid>
                {/*聯絡電話*/}
                <Grid item xs={12}>
                    <TextField name="contactTel" label="Contact Telephone" variant={variant} fullWidth required/>
                </Grid>
                {/*手機*/}
                <Grid item xs={12}>
                    <TextField name="mobilePhone" label="Mobile Phone" variant={variant} fullWidth required/>
                </Grid>

                {/*服務機構地址*/}
                <Grid item xs={12}>
                    <MobileAddress name="serviceOrganizationAddress" subtitle="Service Organization Address" variant='outlined' required withoutCountry/>
                </Grid>
                {/*通訊地址*/}
                <Grid item xs={12}>
                    {/*同服務機構地址*/}
                    {
                        isNew && (
                            <Box fullWidth display='flex' alignItems='center'>
                                <Typography variant="subtitle1" color="textSecondary">{i18n.translate('Contact Address')}</Typography>
                                <Space spacing={2}/>
                                <FormControlLabel name='sameAsServiceOrganizationAddress' control={<Checkbox />} label='Same as Service Organization Address' />
                            </Box>
                        )
                    }
                    <MobileAddress name="mailingAddress" subtitle={isNew? undefined:'Contact Address'} variant='outlined' withoutCountry/>
                </Grid>

                {!newLecturer && <React.Fragment>
                    <Grid item xs={12}>
                        {/*學歷*/}
                        <CustomizedTable name='educations' title={i18n.translate('Education') + '(' + i18n.translate('must not be null') + ')'}
                                         format={education} type='array' readOnly={readOnly} disabled={disabled}/>
                    </Grid>

                    <Grid item xs={12}>
                        {/*經歷*/}
                        <CustomizedTable name='workExperiences' title={i18n.translate('Work Experience') + '(' + i18n.translate('must not be null') + ')'}
                                         format={work} type='array' readOnly={readOnly} disabled={disabled}/>
                    </Grid>

                    <Grid item xs={12}>
                        {/*曾參加過相關的訓練*/}
                        <CustomizedTable name='trainings' title='Training' format={training}
                                         type='array' readOnly={readOnly} disabled={disabled}/>
                    </Grid>

                    { reviewRegistration && <React.Fragment>
                        <Grid item xs={12}/>
                        <Grid item xs={12}>
                            {/*是否為本會審員*/}
                            <SelectField name={'isTafReviewer'} label={'isTafReviewer'} variant={variant} code={'whether'} fullWidth required/>
                        </Grid>
                    </React.Fragment>}

                    {/*not reviewRegistration or isTafReviewer == Y*/}
                    { (!reviewRegistration || isTafReviewer === 'Y') &&
                        <Grid item xs={12}>
                            {/*曾參加過相關的訓練*/}
                            <CustomizedTable name='evaluationHistories' title='Evaluation Histories' format={evaluation}
                                             type='array' readOnly={reviewRegistration || readOnly} pagination={reviewRegistration} disabled={disabled}/>
                        </Grid> }

                    { reviewRegistration && isTafReviewer === 'Y' &&
                        // newEvaluationExperiences
                        <Grid item xs={12}>
                            {/*近三年評鑑紀錄*/}
                            <CustomizedTable name='newEvaluationExperiences' title='newEvaluationExperiences' format={evaluation}
                                             type='array' readOnly={readOnly} disabled={disabled}/>
                        </Grid>
                    }
                </React.Fragment>}
            </Grid>
        </Form>
    );
}

const education = [
    {name:'school', label:'School', required:true, xs:3}, // 學校名稱
    {name:'major', label:'Major', required:true, xs:3}, // 系所
    {name:'studyPeriod', label:'Study Period', required:true, xs:3}, // 修業日期
    {name:'degree', label:'Degree', required:true, xs:3}, // 學位
];

const work = [
    {name:'company', label:'Service Organization', required:true, xs:3}, // 服務機關
    {name:'jobTitle', label:'Position', required:true, xs:3}, // 職稱
    {name:'workPeriod', label:'Work Period', required:true, xs:3}, // 服務日期
    {name:'remark', label:'Remark', required:false, xs:3}, // 備註
];

const training = [
    {name:'course', label:'Course', required:true, xs:3}, // 課程
    {name:'trainingUnit', label:'Training Unit', required:true, xs:3}, // 訓練單位
    {name:'trainingPeriod', label:'Training Period', required:true, xs:2}, // 受訓年月
    {name:'trainingHours', label:'Training Hours', required:true, xs:2}, // 受訓時數
    {name:'remark', label:'Remark', required:false, xs:2}, // 備註
];

const evaluation = [
    {name:'institution', label:'Institutions assessed', required:true, xs:4}, // 受評鑑之機構
    {name:'evaluationDate', label:'Evaluation Date', required:true, xs:4}, // 評鑑日期
    {name:'role', label:'Role Played', required:true, xs:4}, // 擔任之角色
];

const teaching = [
    {name:'course', label:'Teaching Name', required:true, xs:4}, // 授課名稱
    {name:'institution', label:'Handle Institution', required:true, xs:4}, // 辦理機構
    {name:'lecturerDate', label:'Lecture Date', required:true, xs:4}, // 授課日期
];

function CustomizedTable(props) {
    const {title, subTitle, format, value=[], readOnly, disabled, pagination} = props;
    const responsive = useResponsive();
    const isMobile = !responsive.isLargeScreen();

    const isEdit = !(readOnly||disabled);

    const handleChange = ({value}) => {
        props.onChange(new UserEvent({value}));
    };

    const [pageNumber, setPageNumber] = useState(0);
    const [pageSize, setPageSize] = useState(5);


    const handleChangePageNumber = ({pageNumber}) => {
        setPageNumber(pageNumber);
    };
    const handleChangePageSize = ({pageSize}) => {
        setPageNumber(0);
        setPageSize(pageSize);
    };

    const count = value.length;

    if(isEdit && !isMobile) {
        return (
            <Box fullWidth>
                {
                    title && (
                        <Box marginBottom={1}>
                            <Typography color='textSecondary'>{i18n.translate(title)}</Typography>
                            { subTitle && <Typography variant={'body1'}>{i18n.translate(subTitle)}</Typography> }
                        </Box>
                    )
                }
                <Grid container spacing={2} item xs={12}>
                    <Grid item xs={11}>
                        <Grid container spacing={2}>
                            {format.map(column => (
                                <Grid item xs={column.xs} kay={column.name}>
                                    <Typography color='textPrimary'>{i18n.translate(column.label) + (column.required? ' *':'')}</Typography>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
                <Box marginBottom={1}>
                    <Divider variant='fullWidth'/>
                </Box>
                <Forms value={value} divider={false} gap={1} onChange={handleChange}>
                    <Grid container spacing={2} item xs={12}>
                        <Grid item xs={11}>
                            <Grid container spacing={2}>
                                {format.map(column => (
                                    <Grid item xs={column.xs} kay={column.name}>
                                        <TextField name={column.name} variant='outlined' fullWidth required={column.required} size='small'/>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                        <Grid item xs={1}>
                            <Box display="flex" gap={1} alignItems="center" fullHeight>
                                <RemoveAction><Button icon={<Clear/>} size="small" variant="icon" /></RemoveAction>
                                <AddAction><Button icon={<Add/>} size="small" variant="icon" /></AddAction>
                            </Box>
                        </Grid>
                    </Grid>
                </Forms>
            </Box>
        );
    } else if (isEdit && isMobile) {
        return (
            <Box fullWidth marginTop={3}>
                {
                    title && (
                        <Box marginBottom={1}>
                            <Typography color='textSecondary'>{i18n.translate(title)}</Typography>
                            { subTitle && <Typography variant={'body1'}>{i18n.translate(subTitle)}</Typography> }
                        </Box>
                    )
                }
                <Box marginBottom={1}>
                    <Divider variant='fullWidth'/>
                </Box>
                <Forms value={value} divider={false} gap={1} onChange={handleChange}>
                    <Grid container spacing={2} item xs={12}>
                        <Grid item xs={12}>
                            <Grid container spacing={2}>
                                {format.map(column => (
                                    <Grid item xs={12} kay={column.name}>
                                        <TextField label={column.label} name={column.name} variant='outlined' fullWidth required={column.required} size='small'/>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Box display="flex" gap={1} alignItems="center" fullHeight fullWidth>
                                <Box fullWidth>
                                    <RemoveAction><Button startIcon={<Clear/>} text={'刪除'} size="small" fullWidth variant="contained" /></RemoveAction>
                                </Box>
                                <Box fullWidth>
                                    <AddAction><Button startIcon={<Add/>} text={"新增"} size="small" variant="contained" fullWidth /></AddAction>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>
                    </Grid>
                </Forms>
            </Box>
        );
    }

    if (pagination) {
        return (
            <Box fullWidth>
                {
                    title && (
                        <Box marginBottom={1}>
                            <Typography color='textSecondary'><b>{i18n.translate(title)}</b></Typography>
                            { subTitle && <Typography variant={'body1'}>{i18n.translate(subTitle)}</Typography> }
                        </Box>
                    )
                }
                <DataTable data={value} dense pageSize={pageSize} pageNumber={pageNumber}>
                    {format.map(column => (<DataColumn accessor={column.name} label={column.label}/>))}
                </DataTable>
                <DataPagination count={count} pageNumber={pageNumber} pageSize={pageSize} size={'small'}
                                onChangePageSize={handleChangePageSize} onChangePageNumber={handleChangePageNumber}/>
            </Box>
        );
    } else {
        return (
            <Box fullWidth>
                {
                    title && (
                        <Box marginBottom={1}>
                            <Typography color='textSecondary'><b>{i18n.translate(title)}</b></Typography>
                            { subTitle && <Typography variant={'body1'}>{i18n.translate(subTitle)}</Typography> }
                        </Box>
                    )
                }
                <DataTable data={value} dense>
                    {format.map(column => (<DataColumn accessor={column.name} label={column.label}/>))}
                </DataTable>
            </Box>
        );
    }
}

// 學歷/經歷
export function EducationAndWorkExperience(props) {
    const {value={}, change={}, readOnly, disabled} = props;

    return (
        <Form value={value} change={change} onChange={props.onChange}>
            {/*學歷*/}
            <CustomizedTable name='educations' title={i18n.translate('Education') + '(' + i18n.translate('must not be null') + ')'}
                             format={education} type='array' readOnly={readOnly} disabled={disabled}/>
            <Space spacing={10} vertical />
            {/*經歷*/}
            <CustomizedTable name='workExperiences' title={i18n.translate('Work Experience') + '(' + i18n.translate('must not be null') + ')'}
                             format={work} type='array' readOnly={readOnly} disabled={disabled}/>
        </Form>
    );
}

// 曾參加過相關的訓練
export function TrainingExperience(props) {
    const {value={}, change={}, readOnly, disabled} = props;

    return (
        <Form value={value} change={change} onChange={props.onChange}>
            {/*曾參加過相關的訓練*/}
            <CustomizedTable name='trainings' format={training}
                             type='array' readOnly={readOnly} disabled={disabled}/>
        </Form>
    );
}

// 學歷/經歷/曾參加過相關的訓練
export function EducationAndWorkAndTrainingExperience(props) {
    const {value={}, change={}, readOnly, disabled} = props;

    return (
        <Form value={value} change={change} onChange={props.onChange}>
            {/*學歷*/}
            <CustomizedTable name='educations' title={i18n.translate('Education') + '(' + i18n.translate('must not be null') + ')'}
                             format={education} type='array' readOnly={readOnly} disabled={disabled}/>
            <Space spacing={10} vertical/>
            {/*經歷*/}
            <CustomizedTable name='workExperiences' title={i18n.translate('Work Experience') + '(' + i18n.translate('must not be null') + ')'}
                             format={work} type='array' readOnly={readOnly} disabled={disabled}/>
            <Space spacing={10} vertical/>
            {/*曾參加過相關的訓練*/}
            <CustomizedTable name='trainings' title='Training' format={training}
                             type='array' readOnly={readOnly} disabled={disabled}/>
        </Form>
    );
}

// 評鑑/授課 (審查登錄)
export function EvaluationAndTeachingExperience(props) {
    const {value={}, change={}, readOnly, disabled} = props;

    const lecturerQualificationOption = code.get('lecturerQualification');

    return (
        <Fragment>
            <Form value={value} change={change} onChange={props.onChange} readOnly={readOnly} disabled={disabled}>
                <Grid container spacing={2} item xs={12}>
                    {/*基本資格條件*/}
                    <Grid item xs={12}>
                        <Box fullWidth fullHeight display='flex' alignItems='center'>
                            <FormControl>
                                <FormLabel component='legend' focused={false} required>{i18n.translate('Qualification')}</FormLabel>
                                <RadioGroup name='qualification' row>
                                    { lecturerQualificationOption.map((option, index) => <FormControlLabel key={index} value={option.value} control={<Radio/>} label={option.text} />) }
                                </RadioGroup>
                            </FormControl>
                        </Box>
                    </Grid>
                </Grid>
            </Form>
            <Form value={value} change={change} onChange={props.onChange}>
                <Space spacing={5} vertical />
                {/*評鑑經驗*/}
                <CustomizedTable name='evaluationExperiences' title='Evaluation Experience (Latest 3 records)'
                                 format={evaluation} type='array' readOnly={readOnly} disabled={disabled}/>
                <Space spacing={10} vertical />
                <Box marginY={5} />
                {/*授課經驗*/}
                <CustomizedTable name='teachingExperiences' title='Teaching Experience (Latest 3 records)'
                                 format={teaching} type='array' readOnly={readOnly} disabled={disabled}/>
            </Form>
        </Fragment>
    );
}

// 個人資料提供同意書
export function ReleaseOfPersonalInformationAgreement(props) {
    const {value={}} = props;
    const {chineseName} = value;
    const [agreement, setAgreement] = useState({});

    useEffect(() => {
        (async () => {
            const agreement = await agreementService.getReleaseOfPersonalInformationAgreement();
            setAgreement(agreement);
        })();
    }, []);

    return (
        <Fragment>
            <Box fullWidth>
                <Typography>{i18n.translate('I am a lecturer of Taiwan Accreditation Foundation ...')}</Typography>
                {lang.isNotEmpty(agreement) && <RichText value={agreement} fullHeight/>}
            </Box>
            <Form value={value} onChange={props.onChange}>
                <FormControlLabel name='agreement' control={<Checkbox/>} label='I agree'/>
            </Form>
        </Fragment>
    );
}